import "./WhyChooseUs.css";

const REASONS = [
  {
    icon: "/assets/choose-maskanh/experienced-technicians.png",
    title: "Experienced Technicians",
    desc: "Skilled, verified professionals trained on all major AC brands.",
  },
  {
    icon: "/assets/choose-maskanh/fast-response.png",
    title: "Fast Response",
    desc: "WhatsApp confirmation within 30 minutes of your request.",
  },
  {
    icon: "/assets/choose-maskanh/trusted-service.png",
    title: "Trusted Verified Service",
    desc: "Quality workmanship backed by customer satisfaction guarantee.",
  },
  {
    icon: "/assets/choose-maskanh/customer-support.png",
    title: "Customer Support",
    desc: "Friendly support team available to help before and after service.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="why-us" id="why-us">
      <div className="container">
        <div className="why-us-header">
          <span className="section-label">Why Choose Maskanh</span>
          <h2 className="section-title">Built for Kamra &amp; Attock</h2>
          <p className="section-subtitle">
            We make it easy to book verified technicians just like a modern
            form platform, but tailored for local AC services.
          </p>
        </div>

        <div className="why-us-grid">
          {REASONS.map((item) => (
            <article key={item.title} className="why-card">
              <div className="why-icon-wrap">
                <img
                  src={item.icon}
                  alt=""
                  className="why-icon-img"
                  width={32}
                  height={32}
                />
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
